import { render, staticRenderFns } from "./InviteParticipants.vue?vue&type=template&id=35a5508e&scoped=true&"
import script from "./InviteParticipants.vue?vue&type=script&lang=js&"
export * from "./InviteParticipants.vue?vue&type=script&lang=js&"
import style0 from "./InviteParticipants.vue?vue&type=style&index=0&id=35a5508e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a5508e",
  null
  
)

export default component.exports